import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class KPIConfigService {
    private _url = `https://${window.location.host}/api/v0.5/KPIConfig/`;

    constructor(private http: HttpClient) {}

    getKPIConfig(): Observable<IKPIConfigData[]> {
        return this.http.get<any[]>(this._url);
    }

    saveKPIConfig(data: IKPIConfigData[], isDelete = false, mostRecentClientKPIKey = 0) {
        return this.http.post<number>(this._url, {
            data,
            isDelete,
            mostRecentClientKPIKey,
        });
    }
    saveKPITimeboxing(
        data: IKPIConfigData[],
        isDelete,
        currentClientKPIKey,
        stopDate,
        isTimeboxing
    ) {
        return this.http.post<any>(this._url + 'SaveKPITimeboxing', {
            data,
            isDelete,
            currentClientKPIKey,
            stopDate,
            isTimeboxing,
        });
    }

    deleteKPITimeboxing(data: IKPIConfigData[], previousClientKPIKey, makePreviousKPINull) {
        return this.http.post<any>(this._url + 'DeleteKPITimeboxing', {
            data,
            previousClientKPIKey,
            makePreviousKPINull,
        });
    }

    isAllDataValid(data: IKPIConfigData[]) {
        for (let row of data) {
            if (row.errors?.length > 0) {
                return false;
            }
        }
        return true;
    }
}

export interface IKPIConfigData {
    activeDate: Date;
    bestScore: string;
    category: string;
    clientKPIDescription: string;
    clientKPIKey: number;
    errors: string[];
    inActiveDate: Date;
    isActive: boolean;
    isDeleted: boolean;
    isLocked: boolean;
    isPercentage: boolean;
    isWeightedByLA: boolean;
    isWeightedByLADisabled: boolean;
    kpiCategory: string;
    kpiFormat: string;
    kpiMasterKey: number;
    kpiMilestoneBPSKey: number;
    kpiMilestoneCustomKey: number;
    kpiMilestoneKey: number;
    kpiMilestoneStaffingKey: number;
    milestoneKey: number;
    toMilestoneKey: number;
    staffingKey: number;
    lastMod: Date;
    lastModUserKey: number;
    kpiBpsDisplay: string;
    kpiDisplayShort: string;
    staffingPositionKey: number;
    positionAbbv: string;
    kpiCustomTag: string;
    ddbIdentifier: string;
    ddbiAvailable: boolean;
    max: number;
    min: number;
    precision: number;
    range1End: number;
    range2End: number;
    range2Start: number;
    range3End: number;
    range3Start: number;
    range4End: number;
    range4Start: number;
    range5Start: number;
    startDate: string;
    stopDate: string;
    target: number;
    targetError: boolean;
    range2StartError: boolean;
    range3StartError: boolean;
    range3EndError: boolean;
    range4EndError: boolean;
    thirdPartyTypeKey: boolean;
    canEdit?: boolean;
    canDelete?: boolean;
}

export interface IDistributionDialogData {
    dataBackToParent: BehaviorSubject<IKPIConfigData>;
    dataToChild: IKPIConfigData;
}
